import { useAppSelector } from 'app/hooks';
import LazySvg, { MemoizedIconSkeleton } from 'components/LazySvg';
import Img from 'components/Img';
import {
  selectBrandLogoUrl,
  selectBrandName,
} from 'services/brand/brandSelectors';
import { QaHeader } from 'testdata/constants';
import useCoBrandLogo from './useCoBrandLogo';
import styles from './index.module.scss';

function BrandLogo() {
  const logoUrl = useAppSelector(selectBrandLogoUrl);
  const brandName = useAppSelector(selectBrandName);
  const coBrandLogo = useCoBrandLogo();

  /* Bundled, not fetched — so it needs no `logoUrl` and replaces the brand logo outright. */
  if (coBrandLogo) {
    return (
      <div className={styles.logoWrapper}>
        <LazySvg
          name={coBrandLogo}
          role='img'
          aria-label={brandName}
          qaSelector={QaHeader.imageLogo}
        />
      </div>
    );
  }

  if (!logoUrl) {
    return <MemoizedIconSkeleton />;
  }

  return (
    <div className={styles.logoWrapper}>
      <Img
        src={logoUrl}
        alt={brandName}
        width='auto'
        data-qa-selector={QaHeader.imageLogo}
      />
    </div>
  );
}

export default BrandLogo;
